(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["component__accordion"] && !Shopify.designMode) return;
  try {
    window.addEventListener('load', function () {
  document.addEventListener('click', function (e) {
    const title = e.target.closest('.accordion__title');
    if (!title) return; // only handle clicks on accordion titles

    const accordion = title.closest('div');
    const content = accordion.querySelector('.accordion__content');
    if (!content) return;

    if (accordion.classList.contains('open')) {
      // Closing
      content.style.maxHeight = 0;
      content.style.opacity = '0';
      accordion.classList.remove('open');
      content.style.marginBottom = '0px';
    } else {
      // Opening
      accordion.classList.add('open');
      content.style.maxHeight = content.scrollHeight + 'px';
      content.style.opacity = '1';
      content.style.marginBottom = '16px';
    }
  });
});
  } catch(e) { console.error(e); }
})();

})();
